import { memo, useState } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import SessionStore from "../lazyLoaders/session_lazy";
import { TierMap } from "../config/tier_config";
import { Link } from "react-router-dom";

export const AppNavBar = memo(function AppNavBar() {
  const [navItems] = useState(() => {
    const tier = SessionStore.getUserTier();
    return TierMap.hasOwnProperty(tier) ? TierMap[tier] : 1;
  });

  return (
    <Navbar bg="light" variant="light" defaultExpanded expand="lg" className="w-100">
      <Container fluid className="position-relative">
        <Navbar.Toggle aria-controls="main-nav" className="border-0 d-lg-none" />

        {navItems.search_enabled && (
          <Nav className="ms-auto d-lg-none">
            <Nav.Link as={Link} to='/search'><Search size={20} /></Nav.Link>
          </Nav>
        )}
        <Navbar.Collapse id="main-nav">
          <Nav className="gap-2 me-lg-auto">
            {navItems.left.map((item, i) => (
              <Nav.Link key={i} as={Link} to={item.route}>{item.label}</Nav.Link>
            ))}
          </Nav>

          {navItems.search_enabled && (
            <Nav className="ms-lg-auto d-none d-lg-flex">
              <Nav.Link as={Link} to='/search'><Search /></Nav.Link>
            </Nav>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
});
